// You can find the id here
// https://portal.sourcepoint.com/consent_v2/vendor_lists/edit?id=6233296a293cdf6b366969ee&non_iab=false
// Vendor: Google Advertising Products
const GOOGLE_ID: string = '5f1aada6b8e05c306c0597d7';
export default (grants: TSourcePointGrants): boolean => {
  return grants[GOOGLE_ID]?.vendorGrant;
};
